import React from 'react';
import { Search, ChevronRight } from 'lucide-react';
import { ViewMode } from '../types';

interface HeaderProps {
  currentView: ViewMode;
  onViewChange: (view: ViewMode) => void;
  onSearch: (term: string) => void;
  searchTerm: string;
}

export const Header: React.FC<HeaderProps> = ({ currentView, onViewChange, onSearch, searchTerm }) => {
  
  // Reordenação: Gerador, Histórico, Favoritos
  const navItems = [
    { label: 'Gerador', value: ViewMode.INPUT },
    { label: 'Histórico', value: ViewMode.HISTORY },
    { label: 'Favoritos', value: ViewMode.FAVORITES },
  ];

  return (
    <header className="flex flex-col md:flex-row items-start md:items-center justify-between px-8 py-6 gap-4">
      {/* Left: Breadcrumbs/Title */}
      <div className="flex flex-col">
        <div className="flex items-center text-sm text-slate-400 mb-1 font-medium">
          <span>Workspace</span>
          <ChevronRight size={14} className="mx-1" />
          <span className="text-slate-600">Content AI</span>
        </div>
        <h1 className="text-2xl font-bold text-slate-900 tracking-tight">Novo Projeto</h1>
      </div>

      {/* Center: Internal Nav */}
      <nav className="hidden md:flex items-center bg-white p-1.5 rounded-full border border-slate-100 shadow-sm">
        {navItems.map((item) => {
          const isActive = 
            item.value === currentView || 
            (item.value === ViewMode.INPUT && currentView === ViewMode.DASHBOARD);

          return (
            <button
              key={item.label}
              onClick={() => {
                onViewChange(item.value);
                onSearch(''); // Limpa a busca ao trocar de aba
              }}
              className={`px-5 py-2 rounded-full text-sm font-medium transition-all ${
                isActive && !searchTerm 
                  ? 'bg-slate-900 text-white shadow-md' 
                  : 'text-slate-500 hover:text-slate-900 hover:bg-slate-50'
              }`}
            >
              {item.label}
            </button>
          );
        })}
      </nav>

      {/* Right: Search */}
      <div className="flex items-center gap-4">
        <div className="relative hidden lg:block">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={18} />
          <input 
            type="text" 
            placeholder="Buscar transcrições..." 
            value={searchTerm}
            onChange={(e) => onSearch(e.target.value)}
            className="pl-10 pr-4 py-2.5 bg-white border border-slate-200 rounded-full text-sm w-64 focus:outline-none focus:ring-2 focus:ring-slate-900/10 shadow-sm"
          />
        </div>
      </div>
    </header>
  );
};